/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

//import images
import { assetImages } from "constants";
import EmptyDataView from "components/common/EmptyDataView/EmptyDataView";

const CompanyGroupTab = ({
  tabName = "",
  refreshCompany = false,
  setRefreshCompany = () => {},
}) => {
  const params = useParams();

  const token = localStorage.getItem("token");

  const [groupListLoading, setGroupListLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [isDataEmpty, setisDataEmpty] = useState(false);

  //function for get all company groups
  const getAllCompanyGroups = async () => {
    try {
      setGroupListLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_GROUPS +
        `?token=${token}&company=${params.id}&modulefrom=frontend`;

      const response = await getData(requestUrl);

      console.log("response in company group list------>", response);

      setGroupListLoading(false);
      if (response.status) {
        if (response.data.length === 0) {
          setisDataEmpty(true);
        }
        setGroupList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (params.id && tabName === "groups") {
      getAllCompanyGroups();
    }
  }, [params.id, tabName]);

  useEffect(() => {
    if (refreshCompany) {
      getAllCompanyGroups();
      setRefreshCompany(false);
    }
  }, [refreshCompany]);

  if (groupListLoading) {
    return (
      <div className="post_item_outer">
        <div className="post_item">
          {[...Array(5)].map((_, index) => (
            <div className="white_shadow_bx people_bx mb-4" key={index}>
              <div className="people_row">
                <div className="left_people d-flex">
                  {/* Profile Image Placeholder */}
                  <div className="people_profile placeholder-glow">
                    <div
                      className="placeholder rounded-circle"
                      style={{ width: "64px", height: "64px" }}
                    />
                  </div>
                  {/* Profile Info Placeholder */}
                  <div className="people_profile_info ms-3 flex-grow-1">
                    <h3 className="placeholder-glow">
                      <span
                        className="placeholder col-7"
                        style={{ width: "100px" }}
                      />
                    </h3>
                    <h5 className="placeholder-glow">
                      <span
                        className="placeholder col-5"
                        style={{ width: "100px" }}
                      />
                    </h5>
                  </div>
                </div>
                {/* Action Buttons Placeholder */}
                <div className="right_people_btn d-flex gap-3">
                  <div className="placeholder-glow">
                    <span
                      className="placeholder rounded-circle"
                      style={{ width: "36px", height: "36px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (isDataEmpty) {
    return (
      <div className="post_item_outer">
        <div className="post_item">
          <EmptyDataView moduleName="Groups" />
        </div>
      </div>
    );
  }

  return (
    <div className="post_item_outer">
      <div className="post_item">
        {groupList.map((groupData, index) => (
          <div className="white_shadow_bx people_bx" key={index}>
            <div className="people_row">
              <div className="left_people">
                <div className="people_profile">
                  <img
                    width="64"
                    height="64"
                    src={
                      groupData.grouplogo === ""
                        ? assetImages.defaultUser
                        : url.SERVER_URL + groupData.grouplogo
                    }
                    alt=""
                  />
                </div>
                <div className="people_profile_info">
                  <h3>{groupData.title}</h3>
                  <h5>{groupData.country}</h5>
                </div>
              </div>
              <div className="right_people_btn d-flex gap-3">
                <Link
                  to={`/groups/details/${groupData._id}`}
                  className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary text-white rounded-circle"
                  style={{ width: "36px", height: "36px" }}
                >
                  <span className="d-block material-icons fs-lg">
                    arrow_forward
                  </span>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyGroupTab;
